/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { generateHTML, generateJSON, generateText } from "@tiptap/core";
import { tiptapExtensions } from "cms/rich-text/simplicity-composer-tiptap/tiptap-extensions";

// Set configuration options
//    https://github.com/nozer/quill-delta-to-html
const quillConfig = {
    multiLineParagraph: false,
};

export function quillToHtml (richtext) {
    const converter = new QuillDeltaToHtmlConverter(richtext.ops, quillConfig);
    return converter.convert();
}

export function richtextToHtml (richtext) {
    return generateHTML(richtext, tiptapExtensions);
}

export function richtextToText (richtext) {
    return generateText(richtext, tiptapExtensions);
}

export function tipTapToHtml (richtext) {
    return generateHTML(richtext, tiptapExtensions);
}

export function htmlToTipTapJson (html) {
    return generateJSON(html, tiptapExtensions);
}

export function quillToTipTapJson (richtext) {
    const html = quillToHtml(richtext);
    const json = htmlToTipTapJson(html);

    return json;
}
